export const options = [
  { name: "Random", link: "/randommovies" },
  // { name: "Search Movies", link: "/search" },
  { name: "The Like Tree", link: "/liketree" },
  { name: "Search similar", link: "/searchsimilar" },
];
